import "bootstrap/dist/css/bootstrap.css";

import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import {unregister} from "./registerServiceWorker";

import { ThemeProvider } from "@material-ui/core/styles";

import store from "./redux/store";
import clearTheme from "./theme";
import App from "./App";
import AlertProvider from "./components/common/notifications/AlertProvider";

import "./i18n";

// Create browser history to use in the Redux store
const baseUrl = document
  .getElementsByTagName("base")[0]
  .getAttribute("href") as string;

// Get the application-wide store instance, prepopulating with state from the server where available.
// const store = configureStore(history);

ReactDOM.render(
  <BrowserRouter basename={baseUrl || "/"}>
    <Provider store={store}>
      <ThemeProvider theme={clearTheme}>
        <Suspense fallback="">
          <AlertProvider>
            <App />
          </AlertProvider>
        </Suspense>
      </ThemeProvider>
    </Provider>
  </BrowserRouter>,
  document.getElementById("root")
);

unregister();
